import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useT } from "../context/LangContext";
import { CONTACT } from "../lib/site";
import { setConsent } from "../lib/consent";

const withEmail = (text) => {
  const [before, after] = text.split("{email}");
  if (after === undefined) return text;
  return (
    <>
      {before}
      <a href={`mailto:${CONTACT.email}`} className="font-semibold text-terracotta hover:underline">{CONTACT.email}</a>
      {after}
    </>
  );
};

export default function Privacy() {
  const { t } = useT();
  const c = t.privacy;
  return (
    <>
      <PageHero kicker={c.heroKicker} titleLines={c.heroTitleLines} intro={c.heroIntro} />
      <section className="mx-auto max-w-3xl px-5 md:px-8 py-12 md:py-16" data-testid="privacy-page">
        <div className="space-y-8">
          {c.sections.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <h2 className="font-display font-bold tracking-tight text-xl md:text-2xl text-ink">{s.title}</h2>
              <p className="mt-3 text-stone leading-relaxed">{withEmail(s.body)}</p>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-10 flex flex-col gap-6 border-t border-border pt-8 sm:flex-row sm:items-center sm:justify-between">
          <button
            type="button"
            onClick={() => setConsent(null)}
            data-testid="cookie-reset-btn"
            className="inline-flex w-fit items-center rounded-full border border-ink/20 px-6 py-3 text-sm font-semibold text-ink transition-colors duration-200 hover:bg-ink hover:text-bone"
          >
            {c.resetBtn}
          </button>
          <span className="text-sm text-stone">{c.updated}</span>
        </Reveal>
      </section>
    </>
  );
}
